module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image7h.49e63aeb.jpg";